import React from 'react';
import MenuItem from './MenuItem';
import MenuCategory from './MenuCategory';

const WeineTab = ({ wines025, wines075, secco, schnapps }) => {
  return (
    <div className="space-y-16">
      {/* Weine 0,25L */}
      <MenuCategory title="Weine 0,25 Liter" titleColor="text-deep-violet">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {wines025.map((wine) => (
            <MenuItem key={wine.id} item={wine} priceColor="text-neon-pink" />
          ))}
        </div>
      </MenuCategory>

      {/* Weine 0,75L */}
      <MenuCategory title="Weine 0,75 Liter" titleColor="text-deep-violet">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {wines075.map((wine) => (
            <MenuItem key={wine.id} item={wine} priceColor="text-neon-pink" />
          ))}
        </div>
      </MenuCategory>

      {/* Secco & Weinschorle */}
      <MenuCategory title="Secco & Weinschorle" titleColor="text-deep-violet">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {secco.map((item) => (
            <MenuItem key={item.id} item={item} priceColor="text-neon-pink" />
          ))}
        </div>
      </MenuCategory>

      {/* Schnäpse */}
      <MenuCategory title="Schnäpse" titleColor="text-deep-violet">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h4 className="text-xl font-bold text-neon-pink mb-4 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
              Brennerin Franziska
            </h4>
            <div className="space-y-3">
              {schnapps.franziska.map((item) => (
                <div key={item.id} className="glass-card p-4 flex justify-between items-center">
                  <span className="text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {item.name}
                  </span>
                  <span className="text-neon-pink font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {item.price}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-xl font-bold text-neon-pink mb-4 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
              Klassiker
            </h4>
            <div className="space-y-3">
              {schnapps.klassiker.map((item) => (
                <div key={item.id} className="glass-card p-4 flex justify-between items-center">
                  <span className="text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {item.name}
                  </span>
                  <span className="text-neon-pink font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {item.price}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </MenuCategory>
    </div>
  );
};

export default WeineTab;
